var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right-left 1 (Transfer icon)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#3ECF8E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.75 14.7917H24.5L24.4988 18.9167C24.4988 19.3643 24.7641 19.7694 25.1742 19.948C25.5844 20.1267 26.062 20.0454 26.3897 19.7415L31.6397 14.8664C31.8781 14.6417 32 14.3417 32 13.9995C32 13.6573 31.88 13.3981 31.6403 13.1754L26.3903 8.30031C26.0629 7.99637 25.585 7.91495 25.1748 8.09368C24.7647 8.27242 24.4993 8.67776 24.4993 9.12495L24.5 13.2916H8.75C8.33544 13.2916 8 13.6292 8 13.9995C8 14.3698 8.33544 14.7917 8.75 14.7917ZM26 10.0263L30.3242 14.0417L26 18.0589V10.0263ZM31.25 25.2497H15.5L15.5012 21.1668C15.5012 20.7193 15.2359 20.3141 14.8258 20.1355C14.4156 19.9569 13.9391 20.0371 13.6109 20.3418L8.36094 25.2169C8.11995 25.4419 8 25.7419 8 25.9997C8 26.2575 8.11995 26.602 8.35972 26.8247L13.6097 31.6998C13.9371 32.0037 14.415 32.085 14.8252 31.9063C15.2375 31.7701 15.5 31.3623 15.5 30.917V26.7497H31.25C31.6646 26.7497 32 26.4142 32 26.0419C32 25.6695 31.6625 25.2497 31.25 25.2497ZM14 30.0591L9.67578 26.0419L14 22.0246V30.0591Z",
    fill: "#E5E5EB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.9d30a06a04dff581c26d60ae756f1075.svg";
export { ForwardRef as ReactComponent };